import Relay from 'react-relay';

export default {
  viewer: () => Relay.QL`query { conversation(id: $projectId) }`
};



/** WEBPACK FOOTER **
 ** ./src/queries/ConversationIdQuery.js
 **/